import type { AdminRole } from '@/lib/api-admin';

/**
 * 쇼핑 정책 설정 RBAC. cart(order-service) / wishlist(user-service) 양측 BE 계약이
 * 동일하게 `@PreAuthorize hasAnyRole('SUPER_ADMIN','OPS_ADMIN')` 를 건다.
 * read·write 동일 게이트(설정 페이지 전체가 운영 권한 — order 기본설정 페이지와 동일).
 */
export const SHOPPING_POLICY_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
